<template>
  <nav class="navbar navbar-expand-lg navbar-light fb-navbar">
    <div class="container-fluid fb-container-fluid">
      <div class="fb-navbar-container">
        <a
          href="#"
          class="navbar-brand fb-navbar-brand">
          <svg
            version="1.1"
            class="fb-svg logo-icon"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 144 126"
            style="enable-background:new 0 0 144 126;"
            xml:space="preserve">
            <path
              class="fb-path box"
              d="M85.1,126c-6.8,0-10.7,0-10.7,0c0.9-2.7,1.8-5.4,2.9-8.1c4-9.6,9-18.8,15.1-27.2 c6.8-9.4,14.5-18.1,23.1-25.9c1.6-1.5,3.2-2.9,4.7-4.2l0,0c3.4-2.9,6.9-5.7,10.5-8.4l0,0c1.7-1.3,3.3-2.4,4.7-3.4 c4.7-3.2,7.9-5.1,8.4-5.4l0,0c0,0-10.7,9.4-13.1,14l0,0V126H85.1L85.1,126L85.1,126z M114.6,81.3C104.8,91.5,96.5,103,90,115.5h30.4 v-40C120.1,75.7,116.6,79.2,114.6,81.3L114.6,81.3z M4.9,113.7v-8.6l0,0V0h126v13.1l0,0v11c-21.1,8.8-41.4,19.4-60.7,31.7 c-13,8.3-25.2,17.6-36.6,28C21.2,95.3,7.3,113.8,0,126C0,126,3.4,116.9,4.9,113.7L4.9,113.7z M15.4,86.7c3.9-4.5,8.1-8.7,12.5-12.7 c14.3-12.6,29.7-23.8,46.2-33.3c12.9-7.6,26.2-14.4,39.8-20.5c2.3-1.1,4.5-2,6.4-2.8v-6.8h-105L15.4,86.7z" />
            <path
              class="fb-path lines"
              d="M42.9,125.9h-12c4.4-7.8,9.4-15.2,14.9-22.3h10.4c-4.9,7-9.2,14.5-12.8,22.3L42.9,125.9z M59.7,98 h-9.4c4.3-5,8.9-10,13.7-14.7h8.8C68.3,88,64.2,92.9,60.3,98H59.7z M75.5,79.8h-7.9c4.1-3.8,8.4-7.6,12.9-11.2H88 c-4.1,3.6-8.1,7.4-11.9,11.2H75.5z M90.6,65.8h-6.5c4.1-3.1,8.3-6.2,12.6-9.1h5.9c-3.9,3-7.8,6-11.4,9.1H90.6z M104.9,54.6 L104.9,54.6h-5c7.2-4.6,14.6-8.8,22.3-12.5c5.1-2.5,8.3-3.9,8.6-4l0,0c-8.8,5-17.3,10.5-25.4,16.5H104.9z" />
          </svg>
        </a>
        <div class="fb-navbar-heading">
          <span>
            <svg
              version="1.1"
              class="fb-svg logo-text"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 541.1 60.7"
              style="enable-background:new 0 0 541.1 60.7;"
              xml:space="preserve">
              <path
                class="fb-path text"
                d="M436.2,56.4c-4.7-2.5-8.6-6.2-11.3-10.7c-2.7-4.6-4.2-9.9-4.1-15.3 c-0.1-5.4,1.3-10.7,4.1-15.3c2.7-4.5,6.6-8.2,11.3-10.7c5-2.6,10.6-4,16.2-3.9c5.6-0.1,11.2,1.2,16.2,3.9c4.7,2.5,8.6,6.2,11.3,10.7 c2.8,4.6,4.2,9.9,4.1,15.3c0.1,5.4-1.4,10.7-4.1,15.3c-2.7,4.5-6.6,8.2-11.3,10.7c-5,2.6-10.5,4-16.2,3.9 C446.7,60.3,441.2,59,436.2,56.4z M443.1,14.2c-2.7,1.5-5,3.8-6.5,6.6c-1.6,2.9-2.4,6.2-2.4,9.6c-0.1,3.3,0.8,6.6,2.4,9.6 c1.5,2.7,3.8,5,6.5,6.6c2.8,1.6,6,2.4,9.2,2.4s6.4-0.8,9.2-2.4c2.7-1.5,5-3.8,6.5-6.6c1.6-2.9,2.4-6.2,2.4-9.6 c0.1-3.3-0.8-6.6-2.4-9.6c-1.5-2.7-3.8-5-6.5-6.6c-2.8-1.6-6-2.4-9.2-2.4C449.1,11.8,446,12.6,443.1,14.2L443.1,14.2z M194.7,57.1 c-4-1.9-7.4-4.9-9.7-8.6c-2.3-3.9-3.5-8.4-3.4-12.9c-0.1-6.2,1.4-12.3,4.4-17.8c2.9-5.3,7.3-9.7,12.6-12.7 c5.8-3.2,12.3-4.8,18.9-4.7c4.5-0.1,9.1,0.7,13.3,2.3c3.6,1.4,6.8,3.7,9.2,6.7l-6,5.1c-1.9-2.2-4.3-4-7.1-5 c-3.1-1.1-6.4-1.7-9.8-1.6c-5-0.1-10,1.1-14.3,3.6c-4,2.3-7.3,5.7-9.6,9.8c-2.3,4.2-3.4,9-3.4,13.8c0,5.4,1.8,9.7,5.3,12.9 s8.6,4.8,15.2,4.8c4.7,0.1,9.2-1.2,13.2-3.7l3.8-19.1h8l-4.5,23c-2.9,2.4-6.2,4.2-9.8,5.3c-3.7,1.3-7.6,1.9-11.5,1.9 C204.4,60.4,199.3,59.3,194.7,57.1z M317.2,59.6l10.2-51.1h-19.9l1.4-7.3h48.3l-1.5,7.3h-19.9l-10.3,51.1H317.2z M283.5,59.6 l5.2-25.9h-33.5L250,59.6h-8.3l11.7-58.4h8.3l-5,25h33.5l5-25h8.3l-11.7,58.4H283.5z M158.9,59.6l11.7-58.4h8.3l-11.7,58.4H158.9z M106.7,59.6l11.7-58.4h41.2l-1.4,7.3h-33l-3.6,17.9H151l-1.4,7.1h-29.4l-3.8,18.9h34.1l-1.4,7.3L106.7,59.6z M89.1,59.6L79,41.7 H61.8l-3.5,17.9h-8.4L61.5,1.2h21.8c6.8,0,12.1,1.5,15.9,4.5s5.6,7.2,5.6,12.6c0,5.7-1.5,10.5-4.6,14.3c-3.3,4-7.9,6.8-12.9,7.9 l10.7,19L89.1,59.6z M63.2,34.6h14.4c6,0,10.7-1.3,13.9-4c3.3-2.7,4.9-6.5,4.9-11.6c0-3.5-1.2-6.1-3.6-7.9C90.5,9.3,87,8.4,82.5,8.4 H68.4L63.2,34.6z M0.6,59.6L12.3,1.2h41.2l-1.4,7.3h-33L15,28.9h29.4L43,36H13.6L9,59.6H0.6z M524.7,59.2l-13.9-20l-13.7,20h-15.3 L503,29.9L482.7,1.5h15.2l13.3,18.7l13-18.7h14.4l-20.1,27.9L540,59.3L524.7,59.2z M365,59.2V1.5h28.2c7,0,12.4,1.3,16.2,4 c3.6,2.4,5.8,6.6,5.7,11c0,2.6-0.7,5.2-2,7.5c-1.4,2.2-3.3,4-5.7,5.2c3.1,0.9,5.8,2.7,7.8,5.2c1.9,2.6,2.9,5.8,2.8,9 c0.2,4.7-2,9.1-5.9,11.7c-3.9,2.7-9.7,4.1-17.2,4.1H365z M378.3,49.2h15.6c3.5,0,6.2-0.6,8-1.7c1.8-1.2,2.8-3.2,2.7-5.4 c0-4.8-3.5-7.2-10.6-7.2h-15.6v14.3C378.4,49.2,378.3,49.2,378.3,49.2z M378.3,25.2h13.3c3.3,0,5.8-0.6,7.5-1.7s2.7-3.1,2.6-5.1 c0.1-2-0.9-4-2.6-5.1s-4.2-1.7-7.5-1.7h-13.3V25.2z" />
            </svg>
          </span>
        </div>
        <a
          href="#"
          class="dropdown-toggle fb-dropdown-toggle"
          :class="{ 'collapsed': isMenuCollapsed }"
          aria-labelledby="menuIcon"
          @click="toggleHamburgerMenu">
          <span class="fb-dropdown-toggle-bar" />
          <span class="fb-dropdown-toggle-bar" />
          <span class="fb-dropdown-toggle-bar" />
          <span class="fb-dropdown-toggle-bar" />
        </a>
        <div class="alert-dot" v-if="hasPersistentAlert === true && isMenuCollapsed === true"><div class="red-dot"></div></div>
      </div>
      <!-- TODO: Add "show" class when you want to display menu -->
      <ul
        class="dropdown-menu fb-dropdown-menu"
        :class="{ 'show': !isMenuCollapsed }"
        aria-labelledby="navbarDropdown">
        <li v-if="hasPersistentAlert">
          <div class="alert-container">
            <div class="icon">
              <img src="../assets/angry-circle.svg" />
            </div>
            <div class="text">
              <span class="title">{{ persistentAlert.alertMessage }}</span>
              {{ persistentAlert.alertMessageDetails }}
            </div>
          </div>
          <div class="divider"></div>
        </li>
        <li v-if="getCurrentTrailerId">
          <!-- TODO: Redirect user to Trailer Profile page -->
          <a
            href="#"
            class="dropdown-item fb-dropdown-item">
            <svg
              class="fb-svg wheel"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 33 33"
              style="enable-background:new 0 0 33 33;"
              xml:space="preserve">
              <path
                class="fb-path wheel"
                d="M15.8,32.5C7,32.1,0.1,24.6,0.5,15.8C0.9,7,8.4,0.1,17.2,0.5s15.7,7.9,15.3,16.7 c-0.4,8.6-7.4,15.3-16,15.3C16.3,32.5,16,32.5,15.8,32.5z M4.5,16.3c-0.1,6.6,5.2,12.1,11.8,12.2c6.6,0.1,12.1-5.2,12.2-11.8 c0.1-6.6-5.2-12.1-11.8-12.2c-0.1,0-0.1,0-0.2,0C10,4.5,4.6,9.8,4.5,16.3L4.5,16.3z M18,26.1v-4.7c0-0.1,0.1-0.2,0.2-0.2 c0.9-0.3,1.7-0.9,2.3-1.7c0.1-0.1,0.1-0.1,0.2-0.1c1.5,0.5,3.1,1,4.6,1.5c0,0,0.1,0,0.1,0c-0.7,1.3-1.6,2.5-2.8,3.4 c-1.3,1.1-2.9,1.7-4.6,2V26.1z M10.8,24.7c-1.4-0.9-2.5-2.2-3.2-3.7c0.1,0,0.1-0.1,0.2-0.1c1.5-0.5,3-1,4.5-1.5c0.1,0,0.2,0,0.3,0.1 c0.6,0.8,1.4,1.3,2.3,1.7c0.1,0,0.2,0.1,0.2,0.2v0c0,1.6,0,3.2,0,4.8c0,0,0,0.1,0,0.2C13.5,26.1,12,25.5,10.8,24.7L10.8,24.7z M14.5,16.5c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2s-0.9,2-2,2c0,0,0,0,0,0h0C15.4,18.5,14.5,17.6,14.5,16.5L14.5,16.5z M25.7,17.9 c-1.3-0.4-2.7-0.9-4-1.3c-0.1,0-0.2-0.1-0.2-0.3c0-1-0.3-1.9-0.9-2.6c-0.1-0.1-0.1-0.2,0-0.3c0.9-1.3,1.9-2.6,2.8-3.8 c0,0,0.1-0.1,0.1-0.1c1.3,1.3,2.2,2.9,2.7,4.6c0.4,1.3,0.4,2.8,0.2,4.1C26.1,18,25.9,18,25.7,17.9L25.7,17.9z M6.9,13.8 c0.5-1.7,1.4-3.2,2.6-4.5c0.2,0.3,0.5,0.7,0.7,1c0.7,1,1.5,2,2.2,3c0.1,0.1,0.1,0.2,0,0.3c0,0,0,0,0,0c-0.6,0.8-0.9,1.8-0.9,2.7 c0,0.1,0,0.2-0.1,0.2c-1.5,0.5-3.1,1-4.6,1.5c0,0-0.1,0-0.1,0C6.4,16.7,6.5,15.2,6.9,13.8L6.9,13.8z M14.8,11.7 c-0.9-1.3-1.9-2.6-2.8-3.9c0,0,0-0.1-0.1-0.1c2.8-1.5,6.3-1.6,9.1,0c0,0,0,0.1-0.1,0.1c-0.9,1.3-1.9,2.6-2.8,3.9 c0,0.1-0.2,0.1-0.3,0.1c0,0,0,0,0,0c-0.9-0.3-1.9-0.3-2.8,0c0,0-0.1,0-0.1,0C14.9,11.7,14.9,11.7,14.8,11.7L14.8,11.7z" />
            </svg>
            <!-- TODO: Display Trailer Type -->
            <span>{{ $t("Header.dryVan") }}{{ getCurrentTrailerId }}</span>
          </a>
        </li>
        <li>
          <a href="#" class="dropdown-item fb-dropdown-item" @click="instructionsClicked">
            <img class="fb-svg wheel" src="../assets/screwdriver-wrench-solid.svg" />
            {{ $t("InstallationInstructions.menuOption") }}
          </a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from "vuex"
import { isNullOrUndefined } from "@/shared/helpers"

export default {
  name: "Header",
  props: {
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
  },
  emits: ["clicked"],
  setup: (props) => {},
  data: () => {
    return {
      isMenuCollapsed: true,
    }
  },
  computed: {
    ...mapGetters([
      "getCurrentTrailerId",
      "getCurrentPersistentAlert"
    ]),
    validateDriverName(){
      return !isNullOrUndefined(this.getUserDetails?.firstName)
    },
    hasPersistentAlert() {
      return !isNullOrUndefined(this.getCurrentPersistentAlert);
    },
    persistentAlert() {
      return this.getCurrentPersistentAlert;
    }
  },
  watch: {},
  created: async () => {},
  methods: {
    clicked() {
      this.$emit("clicked")
    },
    toggleHamburgerMenu(){
      this.isMenuCollapsed = !this.isMenuCollapsed
    },
    instructionsClicked() {
      this.$router.push({ name: "Instructions" })
    }
  },
}
</script>

<style lang="scss" scoped>
.alert-container {
  display: flex;
  flex-direction: row;
  padding: 14px 16px;
}

.alert-dot {
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background-color: #f5f4f2;
  position: absolute;
  top: 21px;
  right: 8px;
}

.red-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: #c1181a;
  margin: 2px;
}

.text {
  color: #c1181a;
  font-size: 15px;
  font-family: "Roboto";
  line-height: 24px;
}

.title {
  font-weight: 700;
}

.icon {
  padding-right: 12px;
  margin-top: -3px;
}

.divider {
  height: 1px;
  width: 100%;
  background-color: #d9d9d9;
  margin: 16px 0px;
}

.fb-svg {
  &.logo-icon {
    height: 32px;
  }

  &.logo-text {
    height: 20px;
  }

  &.driver {
    height: 36px;
  }

  &.wheel,
  &.box {
    height: 32px;
  }
}

.fb-path {
  &.box,
  &.lines {
    fill: $uix-navbar-link-color;
  }

  &.text {
    fill: $uix-paragraph-text-color;
  }

&.driver,
  &.wheel,
  &.box {
    fill: #A3A09D;
  }
}

.fb-navbar-brand {
  height: 48px;
  margin: 0;
  padding: 8px 5px 8px 6px;
  position: relative;
  width: 48px;

  &:focus,
  &:hover {
    .fb-path {
      &.box {
        fill: $uix-color-secondary;
      }
    }
  }
}

.fb-navbar-heading {
  position: relative;
  text-align: center;

  > strong,
  > span {
    display: block;
    position: relative;
  }

  > strong {
    font-size: 1rem; // 16px
    font-weight: 700;
  }

  > span,
  > small {
    font-weight: 400;
  }

  > span {
    font-size: 1rem; // 16px
  }

  > small {
    font-size: 0.875rem; // 14px
  }
}

.fb-dropdown-toggle {
  background-color: transparent !important;
  border: 0 solid transparent !important;
  border-radius: 0 !important;
  height: 48px;
  margin: 0 !important;
  padding: 12px !important;
  position: relative;
  width: 48px;

  &::after {
    display: none;
  }

  .fb-dropdown-toggle-bar {
    background-color: $uix-navbar-link-color;
    border-radius: 1px;
    height: 3px;
    position: absolute;
    left: 12px;
    margin: 0 !important;
    right: 12px;
    -webkit-transition: transform 300ms ease-out 100ms;
    -moz-transition: transform 300ms ease-out 100ms;
    -o-transition: transform 300ms ease-out 100ms;
    transition: transform 300ms ease-out 100ms;
    
    &:nth-child(1),
    &:nth-child(4) {
      display: none;
    }
    
    &:nth-child(1) {
      top: 14px;
    }
    
    &:nth-child(4) {
      top: 32px;
    }
    
    &:nth-child(2),
    &:nth-child(3) {
      background-color: $uix-navbar-link-focus-color;
      top: 23px;
    }
    
    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(4) {
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      box-shadow: none;
    }
    
    &:nth-child(2) {
      -webkit-transform: rotate(45deg);
      -moz-transform: rotate(45deg);
      -o-transform: rotate(45deg);
      transform: rotate(45deg);
    }
    
    &:nth-child(3) {
      -webkit-transform: rotate(-45deg);
      -moz-transform: rotate(-45deg);
      -o-transform: rotate(-45deg);
      transform: rotate(-45deg);
    }
  }
  
  .fb-dropdown-toggle-bar + .fb-dropdown-toggle-bar {
    margin-top: 0;
  }
  
  &.collapsed {
    .fb-dropdown-toggle-bar {
      -webkit-transition: transform 0ms ease-out 0ms;
      -moz-transition: transform 0ms ease-out 0ms;
      -o-transition: transform 0ms ease-out 0ms;
      transition: transform 0ms ease-out 0ms;
      
      &:nth-child(1),
      &:nth-child(4) {
        display: block;
      }
      
      &:nth-child(2),
      &:nth-child(3) {
        background-color: $uix-navbar-link-color;
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
      }
    }
  }

  &:focus,
  &:hover {
    .fb-dropdown-toggle-bar {
      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4) {
        background-color: $uix-navbar-link-focus-color;
      }
    }
  }
}

.fb-dropdown-item {
  height: 48px;
  padding: 12px 8px 12px 48px;
  position: relative;

  .fb-svg {
    margin: 0;
    position: absolute;

    &.driver {
      left: 10px;
      top: 6px;
    }

    &.wheel {
      left: 8px;
      top: 8px;
    }

    &.box {
      left: 7px;
      top: 8px;
    }
  }

  &:focus,
  &:hover {
    background-color: $uix-navbar-border-color;
    color: $uix-shade-black;

    .fb-path {
      fill: $uix-color-secondary !important;
    }
  }
}

.fb-dropdown-menu {
  background-color: transparent;
  border: 0 solid transparent;
  border-radius: 0;
  margin: 0;
  max-width: 100%;
  min-width: 100%;
  padding: 10px 0;
  position: relative;
  width: 100%;
}

.fb-navbar-container,
.fb-container-fluid {
  align-content: center;
  align-items: center;
  display: flex;
  gap: 0;
  margin: 0;
  min-height: $uix-navbar-min-height;
  padding: 0;
  position: relative;
  width: 100%;
}

.fb-navbar-container {
  flex-flow: row nowrap;
  justify-content: space-between;
  min-width: 100%;
  max-width: 100%;
}

.fb-container-fluid {
  flex-flow: column nowrap;
  justify-content: space-between;
  max-width: $uix-app-max-width;
  padding: 0 15px;
}

.fb-navbar {
  align-content: flex-start;
  align-items: stretch;
  background-color: $uix-shade-alt-one;
  border-bottom: 5px solid $uix-navbar-border-color;
  display: flex;
  flex-flow: row nowrap;
  gap: 0;
  justify-content: center;
  margin: 0;
  min-height: $uix-navbar-min-height;
  padding: 0;
  position: relative;
  width: 100%;
  z-index: 0;
}
</style>
